import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAlert } from '../components/AlertContext';
import Sidebar from '../components/Sidebar';
import './Dashboard.css';

const Perfil = () => {
  const navigate = useNavigate();
  const { toast } = useAlert();
  const isLocal = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
  const apiBase = isLocal ? `http://${window.location.hostname}:3010` : `${window.location.protocol}//${window.location.hostname}`;
  const [user, setUser] = useState(null);
  const [isRecovering, setIsRecovering] = useState(false);
  const [mensaje, setMensaje] = useState('');

  const handleLogout = () => {
    localStorage.removeItem('user');
    localStorage.removeItem('token');
    navigate('/');
  };

  useEffect(() => {
    const savedUser = localStorage.getItem('user');
    if (!savedUser) return navigate('/');
    setUser(JSON.parse(savedUser));
  }, [navigate]);

  const handleSolicitarCambio = async (e) => {
    e.preventDefault();
    setIsRecovering(true);
    setMensaje('');
    try {
      const resp = await fetch(`${apiBase}/api/perfil/recuperar`, { credentials: 'include', 
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ rut: user.rut })
      });
      const data = await resp.json();
      if (resp.ok) {
        setMensaje(data.message);
      } else {
        toast.error('Error: ' + data.error);
      }
    } catch(err) {
      toast.error('Error de conexión con el servidor.');
    } finally {
      setIsRecovering(false);
    }
  };

  if (!user) return null;

  const initials = (user.nombre || 'U').split(' ').map(w => w[0]).join('').substring(0, 2).toUpperCase();
  const rolLower = (user.rol || '').toLowerCase();
  const rolColor = rolLower === 'admin' || rolLower === 'superadmin' ? 'var(--p-rose)' : rolLower === 'supervisor' ? 'var(--p-indigo)' : rolLower === 'jefatura' ? 'var(--p-amber)' : rolLower === 'operador' ? 'var(--p-blue)' : 'var(--p-slate)';
  const rolIcon = rolLower === 'admin' || rolLower === 'superadmin' ? 'fa-crown' : rolLower === 'supervisor' ? 'fa-chart-line' : rolLower === 'jefatura' ? 'fa-user-tie' : rolLower === 'operador' ? 'fa-screwdriver-wrench' : 'fa-user';

  return (
    <div className="dashboard-layout">
      <Sidebar />

      <main className="main-content">
        <header className="content-header">
          <div className="header-title">
            <h1>
              <i className="fa-solid fa-user-gear" style={{ marginRight: '14px', background: 'linear-gradient(135deg, var(--p-indigo), var(--p-blue))', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}></i>
              Mi Perfil
            </h1>
            <p style={{ color: 'var(--p-slate)', fontSize: '14px', marginTop: '4px', fontWeight: '500' }}>Información de tu cuenta y gestión de credenciales.</p>
          </div>
        </header>

        {user.primer_ingreso === 1 && (
          <div className="p-alert-card warning animate-fade-in" style={{ margin: '0 0 28px', borderLeft: '4px solid var(--p-amber)', background: 'var(--sidebar-accent)', border: '1px solid var(--glass-border)', borderLeftWidth: '4px' }}>
            <div className="alert-content" style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
              <div style={{ fontSize: '24px', color: 'var(--p-amber)' }}><i className="fa-solid fa-triangle-exclamation"></i></div>
              <div>
                <span className="alert-category" style={{ color: 'var(--p-amber)', fontSize: '10px', fontWeight: '800', textTransform: 'uppercase' }}>Acción Requerida</span>
                <p className="alert-text" style={{ margin: 0, color: 'var(--p-navy)', fontSize: '13px' }}>
                  Es tu primer ingreso al sistema. Por seguridad, solicita el enlace de cambio de contraseña aquí abajo antes de continuar.
                </p>
              </div>
            </div>
          </div>
        )}

        {/* Profile Card Hero */}
        <div className="datatable-section animate-fade-in" style={{ marginBottom: '28px', padding: '0', overflow: 'hidden' }}>
          {/* Banner gradient */}
          <div style={{
            height: '120px',
            background: 'linear-gradient(135deg, #1e1b4b 0%, #312e81 30%, #4338ca 60%, #3b82f6 100%)',
            position: 'relative'
          }}>
            <div style={{
              position: 'absolute', inset: 0,
              background: 'radial-gradient(circle at 20% 80%, rgba(255,255,255,0.08) 0%, transparent 50%), radial-gradient(circle at 80% 20%, rgba(255,255,255,0.05) 0%, transparent 40%)'
            }}></div>
          </div>

          <div style={{ padding: '0 36px 32px', marginTop: '-50px', position: 'relative', zIndex: 2 }}>
            <div style={{ display: 'flex', alignItems: 'flex-end', gap: '24px', marginBottom: '28px' }}>
              {/* Avatar */}
              <div style={{
                width: '96px', height: '96px', borderRadius: '24px',
                background: 'linear-gradient(135deg, var(--p-indigo), var(--p-blue))',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                color: 'white', fontSize: '32px', fontWeight: '800',
                border: '4px solid var(--bg-main)',
                boxShadow: '0 8px 24px rgba(99, 102, 241, 0.35)'
              }}>
                {initials}
              </div>
              <div style={{ paddingBottom: '8px' }}>
                <h2 style={{ margin: '0 0 4px', fontSize: '24px', fontWeight: '800', color: 'var(--p-navy)', letterSpacing: '-0.02em' }}>
                  {user.nombre}
                </h2>
                <div style={{ display: 'flex', alignItems: 'center', gap: '12px', flexWrap: 'wrap' }}>
                  <span style={{
                    display: 'inline-flex', alignItems: 'center', gap: '6px',
                    padding: '4px 12px', borderRadius: '8px', fontSize: '12px', fontWeight: '700',
                    background: `${rolColor}15`, color: rolColor, border: `1px solid ${rolColor}25`
                  }}>
                    <i className={`fa-solid ${rolIcon}`} style={{ fontSize: '10px' }}></i>
                    {user.rol_nombre || user.rol.toUpperCase()}
                  </span>
                  <span style={{ color: 'var(--p-slate)', fontSize: '13px', fontWeight: '500' }}>
                    <i className="fa-solid fa-building" style={{ marginRight: '5px', fontSize: '11px' }}></i>
                    {user.departamento || 'General'}
                  </span>
                </div>
              </div>
            </div>

            {/* Info Cards Grid */}
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '16px' }}>
              <div style={{ padding: '18px 20px', background: 'var(--sidebar-accent)', borderRadius: '14px', border: '1px solid var(--glass-border)' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '8px' }}>
                  <i className="fa-solid fa-id-card" style={{ color: 'var(--p-blue)', fontSize: '13px' }}></i>
                  <span style={{ fontSize: '10px', fontWeight: '800', color: 'var(--p-slate)', textTransform: 'uppercase', letterSpacing: '0.08em' }}>RUT</span>
                </div>
                <span style={{ fontSize: '16px', fontWeight: '700', color: 'var(--p-navy)', fontFamily: 'monospace' }}>{user.rut || 'No especificado'}</span>
              </div>

              <div style={{ padding: '18px 20px', background: 'var(--sidebar-accent)', borderRadius: '14px', border: '1px solid var(--glass-border)' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '8px' }}>
                  <i className="fa-solid fa-envelope" style={{ color: 'var(--p-indigo)', fontSize: '13px' }}></i>
                  <span style={{ fontSize: '10px', fontWeight: '800', color: 'var(--p-slate)', textTransform: 'uppercase', letterSpacing: '0.08em' }}>Correo Institucional</span>
                </div>
                <span style={{ fontSize: '15px', fontWeight: '600', color: 'var(--p-blue)' }}>{user.email}</span>
              </div>

              <div style={{ padding: '18px 20px', background: 'var(--sidebar-accent)', borderRadius: '14px', border: '1px solid var(--glass-border)' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '8px' }}>
                  <i className="fa-solid fa-circle-check" style={{ color: 'var(--p-emerald)', fontSize: '13px' }}></i>
                  <span style={{ fontSize: '10px', fontWeight: '800', color: 'var(--p-slate)', textTransform: 'uppercase', letterSpacing: '0.08em' }}>Estado</span>
                </div>
                <span style={{ fontSize: '15px', fontWeight: '700', color: 'var(--p-emerald)' }}>Cuenta Activa</span>
              </div>
            </div>
          </div>
        </div>

        {/* Security Section */}
        <div className="datatable-section animate-fade-in" style={{ overflow: 'hidden' }}>
          <div style={{ padding: '32px' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '8px' }}>
              <div style={{
                width: '40px', height: '40px', borderRadius: '12px',
                background: 'rgba(99, 102, 241, 0.1)', border: '1px solid rgba(99, 102, 241, 0.2)',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                color: 'var(--p-indigo)', fontSize: '16px'
              }}>
                <i className="fa-solid fa-shield-halved"></i>
              </div>
              <div>
                <h3 style={{ margin: 0, color: 'var(--p-navy)', fontSize: '18px', fontWeight: '800' }}>Centro de Seguridad</h3>
                <p style={{ margin: 0, color: 'var(--p-slate)', fontSize: '12px', fontWeight: '500' }}>Gestión de credenciales de acceso</p>
              </div>
            </div>

            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '28px', marginTop: '28px' }}>
              {/* Left: Info */}
              <div>
                <p style={{ color: 'var(--p-slate)', fontSize: '13px', lineHeight: '1.7', margin: '0 0 24px' }}>
                  El cambio de credenciales se realiza mediante un <strong style={{ color: 'var(--p-navy)' }}>Enlace Seguro de un solo uso</strong> enviado a tu correo registrado. Esto protege la integridad de tu cuenta institucional.
                </p>

                <div style={{ background: 'var(--sidebar-accent)', borderRadius: '12px', padding: '16px', border: '1px solid var(--glass-border)' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '10px' }}>
                    <i className="fa-solid fa-envelope" style={{ color: 'var(--p-blue)', fontSize: '13px' }}></i>
                    <span style={{ fontSize: '10px', fontWeight: '800', color: 'var(--p-slate)', textTransform: 'uppercase', letterSpacing: '0.08em' }}>Correo de verificación</span>
                  </div>
                  <div style={{ color: 'var(--p-navy)', fontSize: '15px', fontWeight: '600' }}>{user.email}</div>
                </div>

                <div style={{ marginTop: '16px', padding: '12px 16px', background: 'rgba(245, 158, 11, 0.06)', borderRadius: '10px', border: '1px solid rgba(245, 158, 11, 0.15)' }}>
                  <p style={{ margin: 0, fontSize: '11px', color: 'var(--p-amber)', lineHeight: '1.5', fontWeight: '500' }}>
                    <i className="fa-solid fa-circle-info" style={{ marginRight: '6px' }}></i> 
                    Si no recibes el correo en 5 minutos, revisa tu carpeta de Spam o contacta al administrador de TI.
                  </p>
                </div>
              </div>

              {/* Right: Action */}
              <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', padding: '28px', background: 'var(--sidebar-accent)', borderRadius: '16px', border: '1px solid var(--glass-border)', textAlign: 'center' }}>
                <div style={{
                  width: '64px', height: '64px', borderRadius: '20px',
                  background: 'linear-gradient(135deg, rgba(99, 102, 241, 0.15), rgba(14, 165, 233, 0.10))',
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  color: 'var(--p-indigo)', fontSize: '24px', marginBottom: '20px',
                  border: '1px solid rgba(99, 102, 241, 0.15)'
                }}>
                  <i className="fa-solid fa-key"></i>
                </div>
                <h4 style={{ margin: '0 0 8px', color: 'var(--p-navy)', fontSize: '16px', fontWeight: '700' }}>Cambiar Contraseña</h4>
                <p style={{ color: 'var(--p-slate)', fontSize: '12px', margin: '0 0 24px', lineHeight: '1.5' }}>
                  Recibirás un enlace seguro en tu correo institucional para establecer una nueva contraseña.
                </p>
                <form onSubmit={handleSolicitarCambio} style={{ width: '100%' }}>
                  <button 
                    type="submit" 
                    className="btn-primary" 
                    disabled={isRecovering}
                    style={{ width: '100%', height: '48px', justifyContent: 'center', fontSize: '14px' }}
                  >
                    {isRecovering ? (
                      <><i className="fa-solid fa-circle-notch fa-spin"></i> Validando...</>
                    ) : (
                      <><i className="fa-solid fa-paper-plane"></i> Solicitar Enlace Seguro</>
                    )}
                  </button>
                </form>

                {mensaje && (
                  <div className="animate-fade-in" style={{ marginTop: '16px', padding: '14px', background: 'rgba(16, 185, 129, 0.1)', border: '1px solid rgba(16, 185, 129, 0.2)', borderRadius: '12px', color: 'var(--p-emerald)', fontSize: '13px', display: 'flex', alignItems: 'center', gap: '10px', width: '100%' }}>
                    <i className="fa-solid fa-circle-check" style={{ fontSize: '16px', flexShrink: 0 }}></i>
                    <span>{mensaje}</span>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>

      </main>
    </div>
  );
};

export default Perfil;
